import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { AdaptiveAuthenticationReferenceData } from "@idw-types/state/adaptive-authentication-state";

export const getAdaptiveAuthenticationReferenceDataRequest = async (): Promise<{ data: AdaptiveAuthenticationReferenceData, error: any }> => {
    const route = apiRoutes.reports.adaptiveAuthentication.referenceData;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};